<template lang="pug">
	LayoutPlain
		.container
			.row.justify-content-md-center
				.col-md-7
					.card: .card--body.text-center
						.error--404
							h1.display-2 404
							.error--404-description.text--color_grey We can't seem to find the page you're looking for.

</template>



<script>
	export default {
	}

</script>




<style lang="scss">
	.error--404 {
		padding: 20px 0;
	}
	.error--404-description {
		font-size: 20px;
	}
</style>
